/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Overflow16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 8a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 015 8zm4.5 0a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 019.5 8zM14 8a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0114 8z"
            fill={vars.bdlGray50}
        />
    </AccessibleSVG>
);

export default Overflow16;
